import { useMagneticButton } from "@/hooks/useMagneticButton";
import { forwardRef } from "react";

const MagneticButton = forwardRef(function MagneticButton(
  { children, as: Component = "button", className = "", strength = 0.35, scale = 1.04, ...props },
  forwardedRef
) {
  const magneticRef = useMagneticButton({ strength, scale });

  const setRefs = (node) => {
    magneticRef.current = node;
    if (typeof forwardedRef === "function") {
      forwardedRef(node);
    } else if (forwardedRef) {
      forwardedRef.current = node;
    }
  };

  return (
    <Component ref={setRefs} className={`inline-block ${className}`} {...props}>
      {children}
    </Component>
  );
});

export default MagneticButton;
